export const endpoints = {
    LEADS_PRESIGNED:`auth/v1/leads/pre-signed`,
    OFFLINE_UPLOAD_CSVS:`auth/v1/leads/offline-upload-csvs`,
    GET_UPLOAD_CSVS:`auth/v1/leads/offline-upload-csvs`,
    GET_DOWNLOAD_CSV:`auth/v1/leads/download-students-csv`,
}